'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'space-station-moon';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e033';
var svgPathData = ['M32 256C32 132.3 132.3 32 256 32S480 132.3 480 256c0 14.8-1.4 29.3-4.2 43.3-2.1 .7-4.2 1.5-6.5 2.3-36.3 13.1-99.5 35.8-213.3 35.8S79 314.7 42.7 301.6c-2.3-.8-4.4-1.6-6.5-2.3-2.7-14-4.2-28.5-4.2-43.3zm15.2 81.2c39.2 13.6 104 32.3 208.8 32.3s169.6-18.7 208.8-32.3C432.3 420.8 351.1 480 256 480S79.7 420.8 47.2 337.2zM104 160a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z', 'M32 256C32 132.3 132.3 32 256 32S480 132.3 480 256c0 14.8-1.4 29.3-4.2 43.3-2.1 .7-4.2 1.5-6.5 2.3-36.3 13.1-99.5 35.8-213.3 35.8S79 314.7 42.7 301.6l0 0c-2.3-.8-4.4-1.6-6.5-2.3-2.7-14-4.2-28.5-4.2-43.3zM256 369.4c104.8 0 169.6-18.7 208.8-32.3-32.5 83.6-113.8 142.8-208.8 142.8S79.7 420.8 47.2 337.2c39.2 13.6 104 32.3 208.8 32.3zM256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zM136 160a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0zm-88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSpaceStationMoon = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;